import type { OrderExportColumnKey } from "@/modules/orders/domain/contracts";
import { Button } from "@devhop/ui";
import { DownloadIcon } from "lucide-react";
import { useState } from "react";
import { OrdersExportModal } from "./OrdersExportModal";

type OrdersToolbarProps = {
  onExportCsv?: (columns: OrderExportColumnKey[]) => void | Promise<void>;
  exportCsvLoading?: boolean;
  canExportCsv?: boolean;
};

export function OrdersToolbar({
  onExportCsv,
  exportCsvLoading = false,
  canExportCsv = false,
}: OrdersToolbarProps) {
  const [exportOpen, setExportOpen] = useState(false);

  return (
    <div className="mb-2 flex flex-col gap-4">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <div>
          <h2 className="font-bold text-2xl tracking-tight">ຄຳສັ່ງຊື້</h2>
          <p className="text-muted-foreground">
            ເບິ່ງລາຍການຄຳສັ່ງຊື້ ແລະ ຈັດການສະຖານະ
          </p>
        </div>
        {onExportCsv && (
          <>
            <Button
              variant="outline"
              onClick={() => setExportOpen(true)}
              disabled={!canExportCsv || exportCsvLoading}
              title={
                canExportCsv
                  ? undefined
                  : "ບໍ່ມີຂໍ້ມູນຕາມຕົວກອງ ຫຼື ກຳລັງໂຫຼດ"
              }
            >
              <DownloadIcon className="h-4 w-4" />
              ສົ່ງອອກ CSV
            </Button>
            <OrdersExportModal
              open={exportOpen}
              onOpenChange={setExportOpen}
              confirmLoading={exportCsvLoading}
              onConfirm={async (columns) => {
                await onExportCsv(columns);
                setExportOpen(false);
              }}
            />
          </>
        )}
      </div>
    </div>
  );
}
